import { createAction } from '@reduxjs/toolkit'

import type { AgencySignOn } from 'apps/agency/agencyInterfaces'

export interface AgencyCommissionsFilters {
  startDate: string
  endDate: string
}

export const agencySignOnFieldsUpdated = createAction<Partial<AgencySignOn>>(
  'agency/signon/fieldsUpdated',
)

export const agencyCommissionsFilterUpdated = createAction<AgencyCommissionsFilters>(
  'agency/commissions/filterUpdated',
)
